// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBarL1LkEiUexar1GZwKJPJ5C6EXPLqNdk',
    authDomain: 'bender-7466b.firebaseapp.com',
    databaseURL: 'bender-7466b.firebaseapp.com',
    projectId: 'bender-7466b',
    storageBucket: 'gs://bender-7466b.appspot.com/'
    }
};


// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/environments/environment.ts